var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mv-tabs',{attrs:{"tabsHeaders":_vm.tabsHeaders},on:{"tabs":function($event){_vm.tabs = $event}},scopedSlots:_vm._u([{key:"leftContainer0",fn:function(){return [_c('div',[_c('ExpenseSearch',{on:{"search":_vm.search}})],1)]},proxy:true}])})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5df4cd30","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/reports/consultstatus/consultstatus.vue
// module id = null
// module chunks = 